import { FC, Children, cloneElement, ReactElement } from "react";
import { useAppSelector } from "../store";
import { isPermitted } from "../helpers/permissions/featurePermission";

type DisabledProps = {
  editPermissions: string;
};

export const Disabled: FC<React.PropsWithChildren<DisabledProps>> = ({
  editPermissions,
  children,
}) => {
  const actualPermissions =
    useAppSelector((state) => state.company.company?.featurePermissions) ?? [];

  const newChildren = Children.map(children, (child) => {
    const childElement = child as ReactElement<any>;
    const hasPermission = isPermitted(actualPermissions, editPermissions);
    const childDisabled = !!childElement.props?.disabled;

    // Only set disabled if: permissions are missing OR child is already disabled
    return cloneElement(childElement, {
      disabled: !hasPermission || childDisabled,
    });
  });

  return <>{newChildren}</>;
};
